import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BodyText } from '@paypalcorp/pp-react-text';

export class ConfirmationReturnText extends Component {
  render() {
    return (
      <div className="confirmation_reciept_wrapper">
        <BodyText className="text-center">{this.props.returnText}</BodyText>
      </div>
    );
  }
}

export default ConfirmationReturnText;

ConfirmationReturnText.propTypes = {
  returnText: PropTypes.string,
};
